import {
	getExams as getExamsRequest,
	getExam as getExamRequest,
	getExamCount as getExamCountRequest,
} from "../../domain/exams"

export const EXAMS_SET = "EXAMS_SET"
export const EXAM_SET = "EXAM_SET"
export const EXAM_CLEAR = "EXAM_CLEAR"
export const EXAMS_REQUEST = "EXAMS_REQUEST"
export const EXAMS_REQUEST_DONE = "EXAMS_REQUEST_DONE"
export const EXAM_COUNT_SET = "EXAM_COUNT_SET"

export const setExams = data => ({ type: EXAMS_SET, payload: data })

export const setExam = data => ({ type: EXAM_SET, payload: data })

export const clearExam = () => ({ type: EXAM_CLEAR })

export const examsRequest = () => ({ type: EXAMS_REQUEST })

export const examsRequestDone = () => ({ type: EXAMS_REQUEST_DONE })

export const setExamCount = count => ({ type: EXAM_COUNT_SET, payload: count })

export const getExams = () => dispatch => {
	dispatch(examsRequest())
	return getExamsRequest()
		.then(res => {
			dispatch(setExams(res.data.data.groups))
			dispatch(examsRequestDone())
			return res.data.data.groups
		})
		.catch(error => {
			dispatch(examsRequestDone())
			throw error
		})
}

export const getExam = id => dispatch => {
	dispatch(examsRequest())
	// Cleared first, not merged. A paper the viewer is no longer allowed to see
	// -- re-pointed to another child, or unpublished between one visit and the
	// next -- must not leave the previous one on screen while the new request
	// fails.
	dispatch(clearExam())
	return getExamRequest(id)
		.then(res => {
			dispatch(setExam(res.data.data))
			dispatch(examsRequestDone())
			return res.data.data
		})
		.catch(error => {
			dispatch(examsRequestDone())
			throw error
		})
}

export const getExamCount = () => dispatch => {
	return (
		getExamCountRequest()
			.then(res => {
				dispatch(setExamCount(res.data.count))
				return res.data.count
			})
			// The nav icon is a nicety. A failure here must not raise anything at
			// the user: worst case the icon stays hidden, which is also what a
			// student with no papers correctly sees.
			.catch(() => 0)
	)
}
